<!-- 抄表指标 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <Echart ref="option" :options="option" style="height: 100%"></Echart>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    getAction,
    postAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('抄表指标(近一周)'),
        url: {},
        option: {},
      }
    },
    mounted() {
      this.setOption();
    },
    methods: {
      init() {
        this.setOption();
      },
      setOption() {
        let seriesData = []
        // let data = this.waterTypeWaterUse.waterUseList
        // let category = this.waterTypeWaterUse.waterTypeNameList
        // let xAxisData = this.waterTypeWaterUse.monthStrList
        // for(let i = 0;i< data.length;i++) {
        //     seriesData.push({
        //         name: category[i],
        //         type: 'bar',
        //         barMaxWidth: 14,
        //         stack: 'sum',
        //         smooth: true,
        //         symbol: "none",
        //         animationDelay: (i*200)-100,
        //         animationDuration: 300,
        //         data: data[i]
        //     })
        //     if(i == (data.length-1)) {
        //         seriesData[i].itemStyle= {
        //                 normal: {
        //                     barBorderRadius:[20, 20, 0, 0]
        //                 }
        //             }
        //     }
        // }
        seriesData[0] = {
          name: this.$t('应抄'),
          type: 'bar',
          barMaxWidth: 14,
          stack: 'sum',
          smooth: true,
          symbol: "none",
          animationDelay: (0 * 200) - 100,
          animationDuration: 300,
          data: [134, 133, 122, 144, 314, 223, 414]
        }
        seriesData[1] = {
          name: this.$t('实抄'),
          type: 'bar',
          barMaxWidth: 14,
          stack: 'sum1',
          smooth: true,
          symbol: "none",
          animationDelay: (0 * 200) - 100,
          animationDuration: 300,
          data: [134, 133, 122, 144, 314, 223, 414]
        }
        seriesData[2] = {
          name: this.$t('抄表率'),
          type: 'line',
          yAxisIndex: 1,
          symbol: 'circle',
          animationDelay: 1000,
          stack: 'Total',
          smooth: true,
          animationDuration: 300,
          data: [12, 23, 34, 12, 23, 33, 78]
        }
        this.$refs.option.hideLoading()
        this.option = {
          color: ['#0394FF','#50E3C2','#F6BB2F'],
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            },
            // formatter: '{a0}: {c0}<br/>{a1}: {c1}'
          },
          legend: {
            type: 'scroll',
            // data: ['水量'],
            textStyle: {
              color: '#CEE2FF'
            },
            itemHeight: 10,
            right: 0,
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: [this.$t('周一'), this.$t('周二'), this.$t('周三'), this.$t('周四'), this.$t('周五'), this.$t('周六'), this.$t('周日')],
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: ['#074671'],
              }
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          yAxis: [
            {
              type: 'value',
              name: this.$t('抄表(万户)'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                color: '#D1F3FF',
                fontSize: 10
              }
            },
            {
              type: 'value',
              min: 0,
              max: 100,
              interval: 20,
              name: this.$t('抄表率(%)'),
              nameTextStyle: {
                color: '#D1F3FF',
                align: 'center',
              },
              splitLine: {
                show: false,
                lineStyle: {
                  type: 'dotted',
                  color: ['#074671'],
                }
              },
              axisTick: {
                show: false
              },
              axisLine: {
                show: false
              },
              axisLabel: {
                formatter: '{value} %',
                color: '#D1F3FF',
                fontSize: 10
              }
            }
          ],
          series: seriesData
        };
      },
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}

  .ant-radio-button-wrapper {
    color: #fff;
    background: transparent;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #1890FF;
  }
</style>